export const PBX_LOCATIONS_ENDPOINTS = {
  LIST: '/app/v1/locations/',
  DETAIL: (id: number) => `/app/v1/locations/${id}/`,
  AVAILABLE_PHONE_NUMBERS: '/app/v1/locations/available-phone-numbers/',
} as const
